/**
 * @generated SignedSource<<e6d65d10dc2ef25a3b1179d6c5e15cc1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "kind": "InlineDataFragment",
  "name": "readingHistoryPanelArticle"
};
node.hash = "af787a050af248c5e8bd042565039780";
export default node;